const SET_SUPPORT_CONTENT = 'SET_SUPPORT_CONTENT';
const SET_SUPPORT_CALL_WAIT_TIME = 'SET_SUPPORT_CALL_WAIT_TIME';
const SET_SUPPORT_MENU_STATE = 'SET_SUPPORT_MENU_STATE';
const SET_GATED_SUPPORT_OPTIONS_STATE = 'SET_GATED_SUPPORT_OPTIONS_STATE';
const SET_TEXT_FLOW_STEP = 'SET_TEXT_FLOW_STEP';
const SET_TEXT_FLOW_CHANNEL = 'SET_TEXT_FLOW_CHANNEL';
const SET_SUPPORT_CONTENT_LOADING = 'SET_SUPPORT_CONTENT_LOADING';
const SET_MOBILE_SUPPORT_MENU_STATE = 'SET_MOBILE_SUPPORT_MENU_STATE';
const SET_FOCUSED_VIDEO_ID = 'SET_FOCUSED_VIDEO_ID';

const FETCH_WAIT_TIMES_BEGIN = '[support drop down] FETCH_WAIT_TIMES_BEGIN';
const FETCH_WAIT_TIMES_SUCCESS = '[support drop down] FETCH_WAIT_TIMES_SUCCESS';
const FETCH_WAIT_TIMES_FAILURE = '[support drop down] FETCH_WAIT_TIMES_FAILURE';

export {
  SET_SUPPORT_CONTENT,
  SET_SUPPORT_CALL_WAIT_TIME,
  SET_SUPPORT_MENU_STATE,
  SET_GATED_SUPPORT_OPTIONS_STATE,
  SET_TEXT_FLOW_STEP,
  SET_TEXT_FLOW_CHANNEL,
  SET_SUPPORT_CONTENT_LOADING,
  SET_MOBILE_SUPPORT_MENU_STATE,
  SET_FOCUSED_VIDEO_ID,
  FETCH_WAIT_TIMES_BEGIN,
  FETCH_WAIT_TIMES_SUCCESS,
  FETCH_WAIT_TIMES_FAILURE
};
